
// import landingimage from '../Assets/landingpageimage.png'
import adob from '../Assets/adob.png'
import google from '../Assets/google.png'
import aws from '../Assets/Aws.png'
import microsoftimage from '../Assets/microsoftimage.png'
import Aboutsection from '../views/aboutsection/index'
import coreimage1 from '../Assets/coreimage1.png'
import coreimage2 from '../Assets/coreimage2.png'
import coreimage3 from '../Assets/coreimage3.png'
import Moterializeidea from './aboutsection/Moterializeidea'
import securitysvg from '../Assets/securitysvg.png'
import intelligencesvg from '../Assets/intelligencesvg.png'
import speedometersvg from '../Assets/speedometersvg.png'

import React, { useState, useEffect, useRef } from 'react';

import Portfoliocard from './Portfoliocard'
import Blogcard from './Blogcard'
import { useLocation } from 'react-router-dom'

function Home() {
    const middleSectionRef = useRef(null);
    const location = useLocation();
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const section = params.get('section');

        if (section === 'middle') {
            middleSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [location]);

    const [openIndex, setOpenIndex] = useState(null); // Track the index of the currently open FAQ

    const toggleContent = (index) => {
      setOpenIndex(openIndex === index ? null : index); // Toggle between opening and closing the FAQ
    };
    const faqData = [
        { title: 'How long would it take to build our app?', content: 'It takes time to build a properly created app. On average, an app takes between three and nine months to develop, depending on its complexity and structure. However, there are different ways in which our team can expedite the development process.' },
        { title: 'Should I build my mobile app in native or cross-platform?', content: 'The decision between native and cross-platform development depends on various factors, including budget, time, and the specific needs of your app. Native apps generally provide better performance and user experience, while cross-platform apps are more cost-effective and quicker to develop.' },
        { title: 'How much does it cost to build an app?', content: 'The cost of building an app varies greatly depending on the app’s complexity, features, and the platform it is being developed for. Generally, the cost can range from a few thousand to several hundred thousand dollars.' },
        { title: 'Where is your team located?', content: 'Our team is distributed across several locations globally, including the United States, Europe, and Asia. This allows us to provide round-the-clock service to our clients.' },
        { title: 'Why are your estimates higher than other quotes I received?', content: 'Our estimates reflect the quality, expertise, and time commitment we provide to each project. We prioritize delivering a high-quality product that meets all your requirements and offers long-term value.' },
      ];
    
    return (
        <>

            <div className='herosection '>

                <div className=" landing-page-container">

                    <div className="leftherocontanier wow animate__fadeInUp" data-wow-duration="1s">
                        <div className=' textcontainer '>
                            <h1 className="investtext ">
                                Invest In<span className="ideastext"><pre></pre> Your Ideas
                                </span>
                            </h1>
                        </div>
                        <p className="description">NetAesthetics helps businesses build digital experiences ranging from mobile apps to online stores.
                        </p>
                        <div className="fgetcontainer">


                            <div className='getstartedbutton'>
                                <a href='/contact' className="nav-link text-white ">Get Started</a>

                            </div>

                            <a rel="nofollow" href="https://profiles.forbes.com/members/business/profile/Karl-Scarlett-Founder-NetAesthetics-%7C-Great-Dwellings/a6a2abcc-5bd5-406a-9c0e-bc128eb231bf" target="_blank" className="forboslogo">
                                <img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61cdb701856e75483e3c951e_NetAesthetics_Forbes-Logo.svg" loading="lazy" alt="" className="forbosimage" />
                            </a>
                        </div>
                        <div className="linkscontainer">
                            <p className="partnertext">In partnership with</p>
                            <div className='mainlink'>
                                <a rel="nofollow" href="#" className="linkimage">
                                    <img src={adob} loading="lazy" alt="Adobe logo link" className="adobe" />
                                </a>
                                <a rel="nofollow" href="#" className="linkimage">
                                    <img src={google} loading="lazy" alt="Google logo link" className="google" />
                                </a>
                                <a rel="nofollow" href="#" className="linkimage">
                                    <img src={aws} loading="lazy" alt="Amazon Web Services logo link" className="aws" />
                                </a>
                                <a rel="nofollow" href="#" className="linkimage">
                                    <img src={microsoftimage} loading="lazy" alt="Microsoft image" className="microsoft" />
                                </a>
                            </div>
                        </div>
                    </div>


                    {/* <div className="rightherocontainer">


                
                </div> */}

                </div>
            </div>
            <Aboutsection />
            <div className='maincorevalue '>
                <div className='headingcon wow animate__fadeInUp' data-wow-duration="1s">
                    <p style={{ marginBottom: '20px', marginTop: '100px', color: " rgb(204, 196, 196)" }}>
                        <h2 className='coreheading'>Our Core Values</h2>
                        We craft solutions that combine form & function to deliver the best results for our clients
                        <br />
                    </p>
                    <div className='contactusbutton'>
                        <a href='/contact' className="nav-link text-white ">Contact Us</a>

                    </div>
                </div>
                <div className='inetgration_collectoion_list wow animate__fadeInUp' data-wow-duration="1s">
                    <div className='integration_grid '>

                        <div className='integration_item' >
                            <div className='integration_card' style={{}}>


                                <div className='card_content'>
                                    <div> <h3 className='cardheading' >Professional / Artistic</h3></div>
                                    <div> <p style={{ marginTop: "0px", fontSize: '19px' }}>Going beyond our clients' vision and foreseeing the needs of their customers is our forte. Our visionary developers will deliver no less than a master-piece, and that too within your alloted funds.</p></div>
                                </div>
                            </div>
                            <img className='coreimage' src={coreimage1} alt="" />
                        </div>
                        <div className='integration_item_middle'>
                            <div className='integration_card' style={{}}>

                                <div className='card_contentmiddle'>


                                    <div> <h3 className='cardheading' > Persistent</h3></div>
                                    <div> <p style={{ marginTop: "0px", fontSize: '19px' }}>If solving a problem means going extra miles, so be it! Our problem-solving mindset stubbornly keeps us hooked to our projects and thoroughly connected among internal team and external clientele.
                                    </p></div>
                                </div>
                            </div>
                            <img className='coreimage' src={coreimage2} alt="" />
                        </div>
                        <div className='integration_item'>
                            <div className='integration_card' style={{}}>



                                <div className='card_content'>
                                    <div> <h3 className='cardheading' >  Progressive</h3></div>
                                    <div> <p style={{ marginTop: "0px", fontSize: '19px' }}>We believe technology is ever-evolving and we should progress with it. All our products (Mobile Apps, Web Apps and E-commerce) are the epitome of this value.
                                    </p></div>
                                </div>
                            </div>
                            <img className='coreimage' src={coreimage3} alt="" />
                        </div>

                    </div>
                </div>
            </div>
            <Moterializeidea />
            <div className='servicessection '>
                <div className='services_container'>
                    <div className='services_title_con wow animate__fadeInUp' data-wow-duration="1s">
                        <h2 className='services_title'>Services</h2>
                        <p className='services_paragraph'>Our range of services is designed to give you an edge over your competition. We can help you convert your ideas into simple, usable concepts. Let our team of mobile web application development experts help you reach your goals.</p>
                    </div>
                    <div className='services_content_con'>

                        <div className='services_content_con1 wow animate__fadeInUp' data-wow-duration="1s">




                            <div className='services_content_con1_homecon'>



                                <h2 className='services_content_con1_homecon_title'>Government Sector Solutions</h2>
                                <p className='services_content_con1_homecon_paragraph'> NetAesthetics excels in solving critical government sector issues with over a decade of experience.</p>
                                <div className='services_content_con1_homecon_gridcon'>


                                    <div className='servicesgrid1'>



                                        <img className='servicesgrid1image' src={securitysvg} alt="" />
                                        <div>
                                            <h3 className='servicesgrid1title'> Secure Network Infrastructure</h3>
                                            <p className='services_content_con1_homecon_paragraph'>Addressing cybersecurity, our solutions fortify government data and communications against cyber threats, using Azure's networking technology.</p>
                                        </div>

                                    </div>
                                    <div className='servicesgrid1'>

                                        <img className='servicesgrid1image' src={intelligencesvg} alt="" />
                                        <div>
                                            <h3 className='servicesgrid1title'> AI-Enhanced Government Applications</h3>
                                            <p className='services_content_con1_homecon_paragraph'>We streamline public services with AI, enhancing efficiency and citizen engagement through custom applications powered by Azure Cloud.</p>
                                        </div>

                                    </div>
                                    <div className='servicesgrid1'>

                                        <img className='servicesgrid1image' src={speedometersvg} alt="" />
                                        <div>
                                            <h3 className='servicesgrid1title'> Optimized Cloud Services for Government</h3>
                                            <p className='services_content_con1_homecon_paragraph'>Have an idea? Let us take it to the next level, or get mobile apps built from scratch. We’ll deliver high-quality products with measurable results</p>
                                        </div>

                                    </div>

                                    <div class="contactusbutton1"><a href="/contact" class="nav-link text-white ">Contact Us</a></div>

                                </div>
                            </div>
                            <div className='services_content_con1_imagecon'>
                                <img className='services_content_con1_image' src='https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/656d005ef552eddb5ab4f781_NetAesthetics-Asset-Government-Solutions.webp' alt="" />
                            </div>
                        </div>
                        <div className='services_content_con2 wow animate__fadeInUp' data-wow-duration="1s">



                            <div className='services_content_con2_imagecon'><img className='services_content_con2_image' src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61caebc855dce2dd289556bc_NetAesthetics_Services_eCommerce-Solution.png" alt="" /></div>
                            <div className='services_content_con2_homecon'>

                                <h2 className='services_content_con2_homecon_title'>eCommerce Development</h2>
                                <p className='services_content_con2_homecon_paragraph'>With 10+ years of industry experience, our e-commerce development team can help you transform your site into a scalable and intuitive shopping experience for your customers.</p>
                                <div className='services_content_con1_homecon_gridcon'>
                                    <div className='servicesgrid1'>
                                        <img className='servicesgrid1image' src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61afe207ded666db550c0bb5_NetAesthetics_Services_Megento-Logo.svg" alt="" />
                                        <div>
                                            <h3 className='servicesgrid1title'> Magento Web Development</h3>
                                            <p className='services_content_con1_homecon_paragraph'>Impeccable single-system e-commerce experiences with our certified Magento developers for B2B and B2C customers. Get everything from catalogs to payments.</p>
                                        </div>

                                    </div>
                                    <div className='servicesgrid1'>
                                        <img className='servicesgrid1image' src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61afe207ded666db550c0bb5_NetAesthetics_Services_Megento-Logo.svg" alt="" />
                                        <div>
                                            <h3 className='servicesgrid1title'> Magento Integration & Migration</h3>
                                            <p className='services_content_con1_homecon_paragraph'>Let our Magento certified experts handle the integration process with any system of your choice and seamlessly upgrade to the latest Magento version</p>
                                        </div>

                                    </div>
                                    <div className='servicesgrid1'>

                                        <img className='servicesgrid1image' src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61afe207ded666db550c0bb5_NetAesthetics_Services_Megento-Logo.svg" alt="" />
                                        <div>
                                            <h3 className='servicesgrid1title'> Adobe Commerce Solutions</h3>
                                            <p className='services_content_con1_homecon_paragraph'>Get tailored solutions on the Adobe Commerce platform for your business by our Adobe professionals. Drive high-quality leads with scalable solutions</p>
                                        </div>

                                    </div>

                                    <div class="contactusbutton1"><a href="/contact" class="nav-link text-white ">Contact Us</a></div>

                                </div>
                            </div>
                        </div>
                        <div className='services_content_con1 wow animate__fadeInUp' data-wow-duration="1s">



                            <div className='services_content_con1_homecon'>

                                <h2 className='services_content_con1_homecon_title'>Mobile App Development</h2>
                                <p className='services_content_con1_homecon_paragraph'> We are a mobile app development company, offering high-performance iOS and Android app development services to our clients. We help our clients develop high-quality mobile apps that offer personalized experiences for their users with advanced features like offline data storage, push notifications, geo-location services, and more.</p>
                                <div className='services_content_con1_homecon_gridcon'>
                                    <div className='servicesgrid1'>
                                        <img className='servicesgrid1image' src='https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61afe20679d94b4781988c9f_NetAesthetics_Services_Apple-Logo.svg' alt="" />
                                        <div>
                                            <h3 className='servicesgrid1title'> iOS App Development</h3>
                                            <p className='services_content_con1_homecon_paragraph'>Intuitive, engaging, and responsive Native & Cross-platform iOS apps. Design-oriented UX and UI to deliver natural interfaces for the ultimate product</p>
                                        </div>

                                    </div>
                                    <div className='servicesgrid1'>
                                        <img className='servicesgrid1image' src='https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61afe207cc1aaf5c6cb27ca6_NetAesthetics_Services_Android-Logo.svg' alt="" />
                                        <div>
                                            <h3 className='servicesgrid1title'> Android App Development</h3>
                                            <p className='services_content_con1_homecon_paragraph'>Our team of experts and app professionals has years of experience in creating Android apps for clients all over the world.</p>
                                        </div>

                                    </div>
                                    <div className='servicesgrid1'>

                                        <img className='servicesgrid1image' src='https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61afe20781494bfd8c5c48f7_NetAesthetics_Services_React-Logo.svg' alt="" />
                                        <div>
                                            <h3 className='servicesgrid1title'>React Native App Development</h3>
                                            <p className='services_content_con1_homecon_paragraph'>
                                                Have an idea? Let us take it to the next level, or get mobile apps built from scratch. We’ll deliver high-quality products with measurable results</p>
                                        </div>

                                    </div>

                                    <div class="contactusbutton1"><a href="/contact" class="nav-link text-white ">Contact Us</a></div>

                                </div>
                            </div>
                            <div className='services_content_con1_imagecon'>
                                <img className='services_content_con1_image' src='https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61d27167297bb3e3d2134655_NetAesthetics_Services_Mobile-Solution.png' alt="" />
                            </div>
                        </div>
                        <div className='services_content_con2 wow animate__fadeInUp' data-wow-duration="1s">


                            <div className='services_content_con2_imagecon'><img className='services_content_con2_image' src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/656d10342321a8598c5c6054_NetAesthetics%20Asset%20-%20Web%20Development.webp" alt="" /></div>
                            <div className='services_content_con2_homecon'>

                                <h2 className='services_content_con2_homecon_title'>Web Development</h2>
                                <p className='services_content_con2_homecon_paragraph'>Do you have an idea for a web app but need help launching it? We’ll work with you every step of the way to deliver a solution that meets your budget and timeline. You’ll get the best solution as our experts prioritize adopting the latest industry technologies.
                                </p>
                                <div className='services_content_con1_homecon_gridcon'>
                                    <div className='servicesgrid1'>
                                        <img className='servicesgrid1image' src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61afe2090ac45f0dbedf71f9_NetAesthetics_Services_Stacks-Logo.svg" alt="" />
                                        <div>
                                            <h3 className='servicesgrid1title'>MEAN & MERN Stack Development.</h3>
                                            <p className='services_content_con1_homecon_paragraph'>We build custom web mobile app solutions on MEAN or MERN JavaScript stack with Angular and Node.js</p>
                                        </div>

                                    </div>
                                    <div className='servicesgrid1'>
                                        <img className='servicesgrid1image' src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61afe20781494bfd8c5c48f7_NetAesthetics_Services_React-Logo.svg" alt="" />
                                        <div>
                                            <h3 className='servicesgrid1title'>ReactJS Development</h3>
                                            <p className='services_content_con1_homecon_paragraph'>Get fast, responsive, and manageable Apps & Websites with our custom development solutions on React.js. We’re your business partners every step of the way</p>
                                        </div>

                                    </div>
                                    <div className='servicesgrid1'>

                                        <img className='servicesgrid1image' src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61afe20972651e77661490a6_NetAesthetics_Services_Vue-Logo.svg" alt="" />
                                        <div>
                                            <h3 className='servicesgrid1title'> Vue.JS Development</h3>
                                            <p className='services_content_con1_homecon_paragraph'>Let our experts build you a world-class web app with Vue.js. Get complex JavaScript framework backed by reactive programming for ideal user interface.</p>
                                        </div>

                                    </div>

                                    <div class="contactusbutton1"><a href="/contact" class="nav-link text-white ">Contact Us</a></div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className='tech_stacks_section'>
                <div className='services_title_con wow animate__fadeInUp' data-wow-duration="1s">
                    <h2 className='services_title'>Tech Stacks</h2>
                    <p className='services_paragraph'>We've helped many companies build innovative and scalable apps. Our team have helped startups, businesses, and non-profit organizations of all sizes - our engineers are familiar with the latest technologies and are committed to implementing the best solutions for our clients.</p>
                </div>
                <div className='tools_container wow animate__fadeInUp' data-wow-duration="1s">
                    <div className='tools_links'>
                        <a className='linkcon' href="https://angular.io/" target='_blank'><img className='tech_stacks_logo' src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d272987c0681624592c8fc_NetAesthetics%20Logo%20-%20Angular.svg" alt="" /></a>
                        <a className='linkcon' href="https://reactnative.dev/" target='_blank'><img className='tech_stacks_logo' src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d2729809363441d0ce3b2b_NetAesthetics%20Logo%20-%20React.svg" alt="" /></a>
                        <a className='linkcon' href="https://nodejs.org/en/" target='_blank'><img className='tech_stacks_logo' src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d27296d42196024fd51f7b_NetAesthetics%20Logo%20-%20NodeJS.svg" alt="" /></a>
                        <a className='linkcon' href="https://www.mongodb.com/" target='_blank'><img className='tech_stacks_logo' src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d272982f5b699771b29b19_NetAesthetics%20Logo%20-%20MongoDB.svg" alt="" /></a>
                        <a className='linkcon' href="https://www.apple.com/swift/" target='_blank'><img className='tech_stacks_logo' src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d272988f0c875b4f9bf448_NetAesthetics%20Logo%20-%20Swift.svg" alt="" /></a>
                        <a className='linkcon' href="https://flutter.dev/" target='_blank'><img className='tech_stacks_logo' src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d27297d3f4642d020ef39f_NetAesthetics%20Logo%20-%20Flutter.svg" alt="" /></a>
                        <a className='linkcon' href="https://firebase.google.com/" target='_blank'><img className='tech_stacks_logo' src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d272976c0b781a2088e7c1_NetAesthetics%20Logo%20-%20Firebase.svg" alt="" /></a>
                        <a className='linkcon' href="#" target='_blank'>
                            <div className='number_of_tech_con'>
                                <div className='number_of_tech'>
                                    <strong className='tech50'>50</strong>
                                    <span className='plussign'>+</span>
                                </div>
                                <div className='tech_title'>Technologies</div>
                            </div>
                        </a>
                    </div>
                    <div className='contactusbutton'>
                        <a href='/contact' className="nav-link text-white ">Contact Us</a>

                    </div>
                </div>
            </div >


            <div className='blog_container'>
                <h2 className='services_title wow animate__fadeInUp' data-wow-duration="1s" style={{ marginBottom: '50px', marginTop: '50px' }}>
                    Recent Works
                </h2>
                <Portfoliocard />
                <div className='seemore_con' >
                    <a  href="/portfolio">
                        See More
                    </a>
                </div>
                <h2 className='services_title wow animate__fadeInUp' data-wow-duration="1s" style={{ marginBottom: '50px', marginTop: '150px' }}>
                    Recent Blogs
                </h2>
                <Blogcard />
                <div className='seemore_con'>
                    <a  href="/blog">
                        See All blogs
                    </a>
                </div>
            </div>
            <div id='faqs' className='faqs_section'>
                <div className='faqs_container'>
                    <div className='faqs_items'>
                        <div ref={middleSectionRef} className='services_title_con wow animate__fadeInUp' data-wow-duration="1s" style={{ marginTop: '100px' }}>
                            <h2 className='services_title'>FAQs</h2>
                            <p className='services_paragraph'>When it comes to your website or app development, we're here to answer all your questions. Our team of web and mobile developers is ready to work with you and will lead you through the process.
                            </p>
                        </div>

                        {faqData.map((faq, index) => (
        <div className="card_faq wow animate__fadeInUp" data-wow-duration="1s" key={index}>
          <div className="card_faq_content_top">
            <h3 className="title_h4_size_card_faq">{faq.title}</h3>
            <div className="card_faq_icon_gradient">
              <div 
                className="card_faq_icon_wrapper" 
                onClick={() => toggleContent(index)} 
                
              >
                <div 
                  className="card_faq_icon_1" 
                  style={{ 
                    display: openIndex === index ? 'none' : 'block', 
                    backgroundColor: 'white', 
                    borderRadius: '10000000000000px', 
                    width: '18px', 
                    minHeight: '2px', 
                    position: 'absolute', 
                    
                  }}
                >
                </div>
                <div 
                  className="card_faq_icon_2" 
                  style={{ 
                    display: 'block', 
                    backgroundColor: 'white', 
                    borderRadius: '10000000000000px', 
                    width: '2px', 
                    minHeight: '18px', 
                    position: 'absolute', 
                    transform: openIndex === index ? 'rotate(90deg)' : 'rotate(0deg)' 
                  }}
                >
                </div>
              </div>
            </div>
          </div>
          <div
            className="card-faq-content-bottom"
            style={{
              opacity: openIndex === index ? 1 : 0,
              transform: openIndex === index
                ? "translate3d(0px, 0px, 0px) scale3d(1, 1, 1)"
                : "translate3d(0px, 0px, 0px) scale3d(0.9, 0.9, 1)",
              display: openIndex === index ? "block" : "none",
              width: "520px",
              height: openIndex === index ? "auto" : "0px",
              transition: "all 0.3s ease",
            }}
          >
            <p className="paragraph card-faq">{faq.content}</p>
          </div>
        </div>
      ))}

                    </div>
                </div>
            </div>

        </>
    )
}

export default Home